import {type AppConfig, __NAME__} from './types'

// FIXME: Удалить
const STUB_CONFIG: AppConfig = {
  config: {
    dir: 'ltr',
    lang: 'ru',
    countries: {},
    detectedCountry: 'RU',
    basename: '',
    b2bApiHost: '',
    mapLang: 'ru_RU',
    location: [37.62251, 55.753219],
    branding: 'yandex',
    version: '1.0.0',
    yaAuthProxyHost: '',
  },
  i18n: {},
}

export const config: AppConfig = window[__NAME__] || STUB_CONFIG
